/** @module csi/dgrid/OrderedMultiSelection */
define([
	"dojo/_base/declare",
	"dojo/has",
	"dgrid/Selection"
], function(declare,has,Selection) {

	// use this class for ordered multiple selection only
	var ctrlEquiv = has("mac") ? "metaKey" : "ctrlKey";

	return declare(Selection, {
		_extendedSelectionHandler: function(event, target){
			if(event.button === 2 ? !this.isSelected(target) :
					!(event.keyCode ? event.ctrlKey : event[ctrlEquiv])){

				// validate shift key 
				if(!event.shiftKey) {
					this.clearSelection(null, true);
				}
			}
			this._multipleSelectionHandler(event, target);
		},

		_multipleSelectionHandler: function(event, target){
			var lastRow = this._lastSelected,
				ctrlKey = event.keyCode ? event.ctrlKey : event[ctrlEquiv],
				value;

			if (ctrlKey && this.isSelected(target)) {

				// deselect the selected row
				this.deselect(target);
			} else {
				if(!event.shiftKey){
					value = ctrlKey  ? null : true;
					lastRow = null;
				}

				if (!lastRow) {
					// select the target row
					this.select(target, lastRow, value);
				} else {
					// sort correct order when shift select rows ( start to end instead of  end to start)
					this.select(lastRow, target, value);
				}
				
				if(!lastRow){
					// update the last selected row with current row target for next selection
					this._lastSelected = target;
				}
			}
		}
	});
});